//**************************************************************************//
// Extraer Cesiones de Fa en sii como Tipoing=2: 'Consulta para el Cedente' //
//*********************************************00000************************//
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { TextField, Typography, MenuItem, Button, Box, Tooltip } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { ThemeProvider, useTheme } from '@mui/material/styles';

import { CustomToolbar } from "../../components/datagrid/CustomToolbar"; // DataGrid
import { getCustomTheme } from "../../theme/customTheme";                // Tema

import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { jwtDecode } from 'jwt-decode';
import { RiFileSearchLine } from "react-icons/ri";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; 

// Función para formatear la fecha en "dd-mm-aaaa" //
function formatFecha(fecha) {
  if (!fecha) return ""; // si es null, undefined o vacío → no mostrar nada

  const date = new Date(fecha);
  if (isNaN(date)) return ""; // si no es una fecha válida → no mostrar nada

  const dia = String(date.getDate()).padStart(2, '0');
  const mes = String(date.getMonth() + 1).padStart(2, '0');
  const anio = date.getFullYear();

  return `${dia}-${mes}-${anio}`;
}

const Buscarcesiones3 = ({ setTitle, isSidebarOpen, modo }) => {
  // variable leida desde archivo .env o .env.production //
  const apiUrl = process.env.REACT_APP_API_URL;

  // Uso del Tema //
  const themeBase = useTheme();
  const customTheme = getCustomTheme(themeBase, modo);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [rut, setRut] = useState(''); // Estado para almacenar el rut del usuario desde token //
  const [nomUsuario, setNomUsuario] = useState(''); // Estado para almacenar el nombre del usuario desde token //
  const [tipoUsuario, setTipoUsuario] = useState(''); // Estado para almacenar el tipo de usuario desde token //
  const [tipo, setTipo] = useState('CEDENTE');
  const [rutValido, setRutValido] = useState(true); // Estado para almacenar si el RUT es válido //
  const [DataMessage, setDataMessage] = useState(''); // Estado para el mensaje cuando no haya datos //
  const [loading, setLoading] = useState(false);
  const [fecha, setFecha] = useState(dayjs());
  const [fechaDisplay, setFechaDisplay] = useState('');
  const [bitacora, setBitacora] = useState([]);

  // tamaño de la pantalla //
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  // Cambio de titulo //
  useEffect(() => {
    setTitle(' Extraer Cesiones Cedente');
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setTitle]);

  // Obtiene el ancho disponible para la tabla considerando el sidebar
  const availableWidth = isSidebarOpen ? windowWidth - 220 : windowWidth;

  // Función para verificar la validez del token
  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Obtener el tiempo actual en segundos
      return decoded.exp >= currentTime; // Retorna si el token no ha expirado
    } catch (error) {
      return false; // Si el token no es válido, retornar false
    }
  };

  // Función para manejar la expiración del token y redirigir al login
  const handleTokenExpiration = useCallback(() => {
    Swal.fire({
      icon: 'error',
      title: 'Sesión expirada',
      text: 'El token ha expirado. Por favor, inicia sesión nuevamente.',
      footer: '▶️ Overwatch',
      background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
      color: '#f8fafc',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-text'
      },
      showConfirmButton: false,
      timer: 1500
    });
    sessionStorage.removeItem('authToken'); // Limpiar el token de sessionStorage
    // window.location.href = '/login'; // Redirigir al login
    setTimeout(() => {
      window.location.href = '/login'; // Redirigir al login //
    }, 1600); // Un retraso ligeramente mayor que el timer de SweetAlert2 //
  }, []); // Aquí pasamos un array vacío porque `handleTokenExpiration` no depende de nada en particular

  // Validación del Rut (Módulo 11) //
  const validarRut = (rut) => {
    let valor = rut.replace(/\./g, '').replace('-', '');
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
    return dv === dvEsperado;
  };

  // Función para convertir la fecha de formato yyyy-mm-dd a ddmmaaaa
  const formatFechaDisplay = (fecha) => {
    const [anio, mes, dia] = fecha.split('-');
    return `${dia}${mes}${anio}`; // ddmmaaaa
  };

  // Asignar el valor del usuario del token al RUT //
  useEffect(() => {
    const token = sessionStorage.getItem('authToken');
    if (!token || !isTokenValid(token)) {
      handleTokenExpiration(); // Manejar la expiración del token y redirigir
      return; // Evitar continuar con el código si el token es inválido o expirado
    }
    const decoded = jwtDecode(token);
    setRut(decoded.usuario); // Asignar el RUT desde el token //
    setTipoUsuario(decoded.tipo); // Asignar el tipo de usuario desde el token //
    setNomUsuario(decoded.nombre); // Asignar el nombre de usuario desde el token //
  }, [handleTokenExpiration]);

  // Manejo del RUT //
  const handleRutChange = (e) => {
    const valorRut = e.target.value;
    setRut(valorRut);
  };

  // Validación reactiva del RUT //
  useEffect(() => {
    if (rut) {
      const esValido = validarRut(rut);
      setRutValido(esValido);
    } else {
      setRutValido(true); // Si el RUT está vacío, considerarlo válido //
    }
  }, [rut]);

  // Manejo del tipo //
  const handleTipoChange = (e) => {
    setTipo(e.target.value);
  };

  // cargar todos los registros de la tabla bitacora //
  const fetchBitacora = useCallback(async () => {
    try {
      setLoading(true);

      // Obtener el token desde sessionStorage //
      const token = sessionStorage.getItem('authToken');

      if (!token || !isTokenValid(token)) {
        handleTokenExpiration(); // Manejar la expiración del token y redirigir
        return; // Evitar continuar con el código si el token es inválido o expirado
      }
      const response = await axios.post( `${apiUrl}/cesiones/getbitacora`,
        { RutCli: rut }, // rut del cliente
        {
          headers: {
            Authorization: `Bearer ${token}`,  // Incluir el token en el encabezado Authorization
          },
        }
      );

      if (response.data.success && response.data.rows) {
        setBitacora(response.data.rows); // Asignar los datos al estado //

      } else {
        setBitacora([]); // Limpiar datos si no hay resultados //
        Swal.fire({
          position: "center",
          icon: "info",
          title: "No hay datos para mostrar...",
          footer: '▶️ Overwatch',
          showConfirmButton: false,
          background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
          color: '#f8fafc',
          customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-text'
          },
          timer: 1500
        });
      }
      
    } catch (error) {
      setBitacora([]); // También limpiar en caso de error de red
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error al obtener datos",
        text: error.message || "Intenta nuevamente.",
        showConfirmButton: false,
        background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
        color: '#f8fafc',
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text'
        },
        timer: 1500
      });
    } finally {
      setLoading(false);
    }
  }, [setBitacora, apiUrl, rut, handleTokenExpiration]);

  // llamar a cargar bitacora //
  useEffect(() => {
    if (rut) {
      fetchBitacora();
    }
  }, [rut, fetchBitacora]);


  // Configuración de MUI DataGrid //
  const columns = [
    {
      field: 'id',
      headerName: 'Id del Registro',
      width: 130,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Id del Registro" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Id
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'fecha',
      headerName: 'Fecha Bitácora',
      width: 160,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
      renderHeader: () => (
        <Tooltip title="Fecha de la Bitácora" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Fecha
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'tipo',
      headerName: 'Tipo Registro',
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Tipo Registro" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Tipo Registro
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'nombre',
      headerName: "Razón Social",
      width: 400,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Razón Social" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Nombre
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'spacer',
      headerName: '',
      width: 770,
      sortable: false,
      filteable: false,
      disableColumnMenu: true,   // ❗ elimina los 3 puntos
      disableReorder: true,      // evita que se arrastre
      disableExport: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => null,    // ❗ evita que se vea algo raro
    }
  ];

  // Buscar cesiones //
  const fetchCesiones = async () => {
    // Mostrar el loading de SweetAlert2 //
    const swalInstance = Swal.fire({
      title: 'Cargando...',
      text: 'Por favor, espere mientras obtenemos los datos.',
      footer: '▶️ Overwatch',
      background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
      color: '#f8fafc',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-text'
      },
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Mostrar el spinner //
      }
    });

    // Asegurarnos de que el loading dure al menos 0.5 segundos //
    const minLoadingTime = 500; // Tiempo mínimo de 0.5 segundos //

    // Validar RUT
    if (!validarRut(rut)) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'El RUT ingresado no es válido.',
        footer: '▶️ Overwatch',
        allowOutsideClick: false,  // 👈 evita cierre con click afuera
        background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
        color: '#f8fafc',
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text'
        }
      });
      return;
    }

    if (!rut || !tipo) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor, ingrese el RUT y tipo.',
        footer: '▶️ Overwatch',
        allowOutsideClick: false,  // 👈 evita cierre con click afuera
        background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
        color: '#f8fafc',
        customClass: {
          popup: 'swal-custom-popup',
          title: 'swal-custom-title',
          htmlContainer: 'swal-custom-text'
        }
      });
      return;
    }

    try {
      // Obtener el token desde sessionStorage //
      const token = sessionStorage.getItem('authToken');

      if (!token || !isTokenValid(token)) {
        handleTokenExpiration(); // Manejar la expiración del token y redirigir
        return; // Evitar continuar con el código si el token es inválido o expirado
      }

      // Rellenar con ceros a la izquierda para que el rut tenga un largo de 10 //
      // Tipoing:
      // 1: 'Consulta para el Deudor',
      // 2: 'Consulta para el Cedente',
      // 3: 'Consulta para el Cesionario'
  
      const Username = rut.padStart(10, '0');
      const Tipoing = '2'; // consultar por cedente //
      const Fecproc = fechaDisplay;

      const response = await axios.post( `${apiUrl}/extraercesiones/buscarcesiones`,
        { Username, Tipoing, Fecproc },
        {
          headers: {
            Authorization: `Bearer ${token}`,  // Incluir el token en el encabezado Authorization
          },
        }
      );
      if (response.data.success) {
        setDataMessage(response.data.message);
      } else {
        setDataMessage(response.data.message);
      }

    } catch (error) {
      if (error.response && error.response.status === 403) {
        const mensaje='Acceso denegado: el cliente no tiene credenciales informadas';
        setDataMessage(mensaje);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: mensaje,
          footer: '▶️ Overwatch',
          allowOutsideClick: false,  // 👈 evita cierre con click afuera
          background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
          color: '#f8fafc',
          customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-text'
          }
        });
  
      } else {
        const mensaje='Ocurrió un error al procesar la solicitud'
        setDataMessage(mensaje);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: mensaje,
          footer: '▶️ Overwatch',
          allowOutsideClick: false,  // 👈 evita cierre con click afuera
          background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
          color: '#f8fafc',
          customClass: {
            popup: 'swal-custom-popup',
            title: 'swal-custom-title',
            htmlContainer: 'swal-custom-text'
          }
        });
      }

    } finally {
      setTimeout(() => swalInstance.close(), minLoadingTime);  // Cerrar el loading después de procesar la API y el tiempo mínimo
      fetchBitacora();
    }
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          mb: 1,
          mt: 2,
          height: '70px',
          flexWrap: 'wrap', // Permite que los elementos se acomoden en múltiples líneas si es necesario
          maxWidth: '100%',
        }}
      >
        {/* Campo Rut del Usuario */}
        <TextField
          id="rut-input"
          label="Rut"
          value={rut}
          onChange={handleRutChange}
          variant="outlined"
          fullWidth
          required
          error={!rutValido} // Mostrar error si el RUT no es válido //
          helperText={!rutValido ? 'RUT no válido' : ''} // Mensaje de error //
          autoComplete="off" // Desactivar autocompletado //
          disabled={tipoUsuario !== 'USUARIO'} // Deshabilitar si el tipo no es 'USUARIO' //
          sx={{
            width: '120px',
            height: '40px',
            '& .MuiOutlinedInput-root': {
              height: '40px',
              '& input': {
                color: '#ca531f',
                WebkitTextFillColor: '#ca531f',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#ca531f',
            },
          }}
        />

        {/* Campo de Nombre de Usuario */}
        <TextField
          id="nom-usuario-input"
          label="Cliente"
          value={nomUsuario}
          variant="outlined"
          disabled
          sx={{
            width: '480px',
            height: '40px',
            '& .MuiOutlinedInput-root': {
              height: '40px',
              '& input': {
                color: '#ca531f',
                WebkitTextFillColor: '#ca531f',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#ca531f',
            },
          }}
        />

        {/* Campo de tipo */}
        <TextField
          select
          id="rut-tipo"
          label="Tipo"
          value={tipo}
          onChange={handleTipoChange}
          variant="outlined"
          fullWidth
          required
          disabled={tipoUsuario !== 'USUARIO'} // Deshabilitar si el tipo no es 'USUARIO' //
          sx={{
            width: 150,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': { textAlign: 'center',},
          }}
        >
          <MenuItem value="DEUDOR">DEUDOR</MenuItem>
          <MenuItem value="CEDENTE">CEDENTE</MenuItem>
          <MenuItem value="CESIONARIO">CESIONARIO</MenuItem>
        </TextField>

        {/* Campo de Fecha */}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            label="Fecha"
            value={fecha}
            onChange={(newValue) => {
              setFecha(newValue);

              if (newValue && dayjs(newValue).isValid()) {
                const isoStr = dayjs(newValue).toISOString().split('T')[0];
                const formateada = formatFechaDisplay(isoStr);
                setFechaDisplay(formateada);
              } else {
                setFechaDisplay('');
              }
            }}
            slots={{
              textField: TextField, // aquí solo pasas el componente
            }}
            slotProps={{
              textField: {
                variant: 'outlined',
                required: true,
                fullWidth: true,
                sx: {
                  width: '150px',
                  height: '40px',
                  '& .MuiOutlinedInput-root': { height: '40px' },
                  '& .MuiInputLabel-root': {
                    top: '-10px',
                    left: '12px',
                    transform: 'none',
                    fontSize: '0.8rem',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>

        {/* Botón Buscar */}
        <Tooltip title="Buscar datos" placement="top" arrow> 
          <Button 
            variant="contained" 
            onClick={fetchCesiones}
            sx={{ 
              width: '160px', 
              height: '40px',
              textTransform: 'none',
              backgroundColor: '#8b888e', // Color de fondo inicial
              color: 'white', // Color del texto en blanco
              '&:hover': {
                backgroundColor: '#9759c7', // Color de fondo al pasar el cursor
                color: 'white', // Color del texto (blanco) al pasar el cursor
              },
              '& .MuiButton-startIcon': {
                color: 'white', // Asegurar que el icono también sea blanco
              },
            }} 
          >
            <RiFileSearchLine className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
            Buscar
          </Button>
        </Tooltip>
      </Box>

      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'block',
          boxSizing: 'border-box',
          p: '1px',
          maxWidth: '98%',
          width: availableWidth, // Ajuste dinámico según sidebar
          overflowX: 'auto',
        }}
      >
        <Box sx={{ mt: 1 }}>
          <ThemeProvider theme={customTheme}>
            <DataGrid
              rows={bitacora}
              columns={columns}
              getRowId={(row) => row.id}
              loading={loading}
              density="compact"
              rowHeight={38}
              headerHeight={40}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
                density: 'compact',
              }}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              slots={{
                toolbar: CustomToolbar,
              }}
              // slots={{
              //   toolbar: GridToolbar,
              // }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 400 },
                },
              }}
              // disableRowSelectionOnClick={false}
              // rowSelectionModel={selectionModel}
              // onRowSelectionModelChange={handleSelectionChange}

              sx={{
                border: 'none',
                backgroundColor: modo === 'dark' ? '#2b2b2b' : '#eaeded',

                // 🎨 CABECERA
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: modo === 'dark' ? '#85c1e9 !important' : '#85c1e9 !important',
                },
                '& .MuiDataGrid-columnHeadersInner': {
                  backgroundColor: modo === 'dark' ? '#85c1e9 !important' : '#85c1e9 !important',
                },
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: modo === 'dark' ? '#85c1e9 !important' : '#85c1e9 !important',
                  color: modo === 'dark' ? '#000 !important' : '#000 !important',
                  fontWeight: 'bold',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                  borderBottom: '2px solid #a9cce3',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'bold',
                  textAlign: 'center',
                  width: '100%',
                },

                // 🔹 permite respetar la alineación por columna
                '& .MuiDataGrid-cell--textLeft': {
                  justifyContent: 'flex-start !important',
                  textAlign: 'left !important',
                },
                '& .MuiDataGrid-cell--textCenter': {
                  justifyContent: 'center !important',
                  textAlign: 'center !important',
                },
                '& .MuiDataGrid-cell--textRight': {
                  justifyContent: 'flex-end !important',
                  textAlign: 'right !important',
                },

                // 🧾 CELDAS
                '& .MuiDataGrid-cell': {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.75rem',
                  lineHeight: 1,
                  textAlign: 'center',
                  p: '2px 8px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  color: modo === 'dark' ? '#B1AAAE' : '#000',
                },

                // 🩶 FILAS
                '& .MuiDataGrid-row': {
                  backgroundColor: modo === 'dark' ? '#222222' : '#f2f3f4',
                  '&:hover': {
                    backgroundColor: modo === 'dark' ? '#3e3633' : '#eaf2f8',
                  },
                },

                // 🧭 FOOTER '#B1AAAE'
                '& .MuiDataGrid-footerContainer': {
                  borderTop: '1px solid #ccc',
                  minHeight: '30px',
                  backgroundColor: modo === 'dark' ? '#3e3633' : '#f1f3f4',
                  color: modo === 'dark' ? '#3e3633' : '#000',
                },

                // 🔹 SCROLL
                '& .MuiDataGrid-virtualScroller': {
                  maxHeight: '600px',
                },

                // Color de selección y le quita la caja de seleción
                '& .MuiDataGrid-cell:focus': {
                  outline: 'none !important',
                },
                '& .MuiDataGrid-cell:focus-within': {
                  outline: 'none !important',
                },
                '& .MuiDataGrid-row.Mui-selected': {
                  backgroundColor: modo === 'dark' ? '#3e3633' : '#B1AAAE !important', // color de fila seleccionada
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: modo === 'dark' ? '#3e3633' : '#B1AAAE !important', // hover opcional
                },
              }}
            />
          </ThemeProvider>
        </Box>
      </Box>

      {DataMessage && (
        <Box
          sx={{
            width: '98%',
            padding: 2,
            marginTop: 4,
            borderRadius: 1,
            border: '1px solid #d32f2f',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" align="center">
            {DataMessage}
          </Typography>
        </Box>
      )}
      <div style={{
          display: 'block', // Habilita el modelo de bloque para el contenedor //
          boxSizing: 'border-box', // Incluye los bordes y el padding en el cálculo de dimensiones //
          padding: '1px', // Añade un poco de espacio para evitar que la tabla toque navBar //
          maxWidth: '98%',
          width: availableWidth, // Tamaño disponible según si esta abierto el sidebar //
          overflowX: 'auto',
        }}>
      </div>
    </div>
  );
};

export default Buscarcesiones3;
